(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trail-featured-products"] && !Shopify.designMode) return;
  try {
    
function initTrailFeatured(scope){
  scope.querySelectorAll('[data-tt-featured]').forEach(root=>{
    if(root.dataset.ready==='true')return; root.dataset.ready='true';
    const viewport=root.querySelector('[data-tt-featured-viewport]');
    const track=root.querySelector('[data-tt-featured-track]');
    const slides=[...root.querySelectorAll('[data-tt-featured-slide]')];
    const progress=root.querySelector('[data-tt-featured-progress]');
    if(!viewport||!track||!slides.length||!progress)return;
    let activeIndex=0,touchStartX=0,touchStartY=0,wheelLocked=false;
    const dots=slides.map((slide,index)=>{ const dot=document.createElement('button'); dot.type='button'; dot.className='tt-featured__dot'; dot.setAttribute('aria-label',`Go to featured product ${index+1}`); dot.addEventListener('click',()=>goTo(index)); progress.appendChild(dot); return dot; });
    const render=()=>{ track.style.transform=`translate3d(-${activeIndex*100}%,0,0)`; dots.forEach((dot,index)=>dot.classList.toggle('is-active',index===activeIndex)); };
    const goTo=index=>{ activeIndex=(index+slides.length)%slides.length; render(); };
    viewport.addEventListener('touchstart',event=>{ const t=event.changedTouches[0]; touchStartX=t.clientX; touchStartY=t.clientY; },{passive:true});
    viewport.addEventListener('touchend',event=>{ const t=event.changedTouches[0],dx=t.clientX-touchStartX,dy=t.clientY-touchStartY; if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.15)goTo(activeIndex+(dx<0?1:-1)); },{passive:true});
    viewport.addEventListener('wheel',event=>{ if(Math.abs(event.deltaX)<18||Math.abs(event.deltaX)<=Math.abs(event.deltaY))return; event.preventDefault(); if(wheelLocked)return; wheelLocked=true; goTo(activeIndex+(event.deltaX>0?1:-1)); window.setTimeout(()=>wheelLocked=false,520); },{passive:false});
    viewport.addEventListener('keydown',event=>{ if(event.key==='ArrowRight'){event.preventDefault();goTo(activeIndex+1);} if(event.key==='ArrowLeft'){event.preventDefault();goTo(activeIndex-1);} });
    render();
  });
}
initTrailFeatured(document); document.addEventListener('shopify:section:load',event=>initTrailFeatured(event.target));

  } catch(e) { console.error(e); }
})();
})();
